import {ResolvedVisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/ResolvedVisualComponent';
import {observable} from 'mobx';
import {createTransformer, ITransformer} from 'mobx-utils';

export interface IVisualComponentRefSnapshot
{
    componentId:string;
    definedBy:string;
    exportName:string;
}

export class VisualComponentRef
{
    public readonly componentId:string;
    public readonly definedBy:string;
    public readonly exportName:string;

    @observable
    public resolvedComponent:ResolvedVisualComponent = null;

    public resolveComponentPromise:Promise<ResolvedVisualComponent> = null;

    public constructor(componentId:string,
                       definedBy:string,
                       exportName:string)
    {
        this.componentId = componentId;
        this.definedBy = definedBy;
        this.exportName = exportName;
    }

    public get isResolved()
    {
        return this.resolvedComponent !== null;
    }

    public static toJson:ITransformer<VisualComponentRef, IVisualComponentRefSnapshot> = createTransformer((visualComponentRef:VisualComponentRef) =>
    {
        return {
            componentId: visualComponentRef.componentId,
            definedBy: visualComponentRef.definedBy,
            exportName: visualComponentRef.exportName
        };
    });

    public static fromJson(json:IVisualComponentRefSnapshot):VisualComponentRef
    {
        return new VisualComponentRef(json.componentId, json.definedBy, json.exportName);
    }

    public static fromJsonDeep(json:IVisualComponentRefSnapshot):VisualComponentRef
    {
        return VisualComponentRef.fromJson(json);
    }
}

export class LocalVisualComponentRef extends VisualComponentRef
{
    public constructor(componentId:string,
                       definedBy:string,
                       exportName:string,
                       resolvedComponent:ResolvedVisualComponent)
    {
        super(componentId, definedBy, exportName);

        this.resolvedComponent = resolvedComponent;
        this.resolveComponentPromise = Promise.resolve(resolvedComponent);
    }
}
